var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCheckSquare16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86667 3.4H12.1333C12.3911 3.4 12.6 3.60893 12.6 3.86667V12.1333C12.6 12.3911 12.3911 12.6 12.1333 12.6H3.86667C3.60893 12.6 3.4 12.3911 3.4 12.1333V3.86667C3.4 3.60893 3.60893 3.4 3.86667 3.4ZM2 3.86667C2 2.83574 2.83574 2 3.86667 2H12.1333C13.1643 2 14 2.83574 14 3.86667V12.1333C14 13.1643 13.1643 14 12.1333 14H3.86667C2.83574 14 2 13.1643 2 12.1333V3.86667ZM6.82931 11.9612L12.1828 4.82328L10.9028 3.86328L6.6562 9.52536L4.90844 7.7776L3.77707 8.90897L6.82931 11.9612Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckSquare16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;